import React from 'react';
import { cn } from '@/lib/utils';

interface GlowCardProps {
  children: React.ReactNode;
  className?: string;
  rounded?: string;
}

const GlowCard = ({ children, className = "", rounded = "xl" }: GlowCardProps) => {
  return (
    <div className={cn(
      "bg-white border border-neutral-200 p-0 shadow-sm hover:shadow-lg hover:-translate-y-0.5 hover:border-neutral-300 transition-[transform,box-shadow,border-color] duration-400 ease-out",
      `rounded-${rounded}`,
      className
    )}>
      {/* Content wrapper */}
      <div className="relative z-10 h-full">
        {children}
      </div>
    </div>
  );
};

export default GlowCard;